// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ThemeIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from theme.svg
 */
export default function ThemeIcon(props: ThemeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ThemeIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8.993.883A1 1 0 0 0 7 1v2l.007.117A1 1 0 0 0 9 3V1zm4.742 2.787a1 1 0 0 0-1.492-1.327l-1.415 1.414-.077.088a1 1 0 0 0 1.492 1.327l1.414-1.415zM8 5c1.552 0 3 1.448 3 3s-1.448 3-3 3-3-1.448-3-3 1.448-3 3-3m-2.828 5.828a1 1 0 0 1 .077 1.327l-.077.088-1.415 1.414a1 1 0 0 1-1.492-1.327l.078-.087 1.414-1.415a1 1 0 0 1 1.415 0M8 12a1 1 0 0 1 .993.883L9 13v2a1 1 0 0 1-1.993.117L7 15v-2a1 1 0 0 1 1-1m4.243-1.172-.088-.077a1 1 0 0 0-1.327 1.492l1.415 1.414.087.078a1 1 0 0 0 1.327-1.492zM16 8a1 1 0 0 0-1-1h-2l-.117.007A1 1 0 0 0 13 9h2l.117-.007A1 1 0 0 0 16 8M3 7a1 1 0 0 1 .117 1.993L3 9H1a1 1 0 0 1-.117-1.993L1 7zm.67-4.735.087.078 1.415 1.414A1 1 0 0 1 3.845 5.25l-.088-.077-1.414-1.415A1 1 0 0 1 3.67 2.265"
        />
      </g>
    </svg>
  );
}
